<template>
  <div class="category">
    <header>
      <div class="header">
        <span>田野商城</span>
      </div>
      <div class="cate_bg">
        <van-search
          placeholder="请输入商品名称"
          v-model="value"
          shape="round"
          @search="search"
          @focus="gosearch"
          class="cate_mar"
        />
      </div>
    </header>
    <!-- 主题 -->
    <main>
      <van-grid
        :border="false"
        :column-num="3"
        gutter="5px"
        style="padding-left:0; background-color:transparent !important;"
      >
        <van-grid-item
          class="van_item"
          v-for="item in classifyList"
          :key="item.operatingPositionId"
          @click="goClassify(item)"
        >
          <van-image fit='cover' :src="item.showImageUrl" class="van_img" />
          <!-- <span class="cate-main-grid-span">{{item.imageName}}</span> -->
        </van-grid-item>
      </van-grid>
    </main>
    <van-loading type="spinner" color="rgb(116, 180, 43)" class="loading" v-if="loading" />
    <!-- 底部导航 -->
    <footer>
       <tabbar :activeNew='active' />
    </footer>
  </div>
</template>

<script>
 import tabbar from "../common/tabbar";
export default {
   components:{
    tabbar
  },
  created() {
    const mm = require("../common/imgUrl");
    this.imgURL = mm.imgURL;
    // 获取客户ID
    this.customerId = localStorage.getItem("customerId");
    // 获取商品列表
    this.getclassifyList()
    // this.$axios.post("/goods/goodsCategory/list").then(res => {
    //   this.classifyList = res.data.data;
    //   this.loading = false
    // });
  },
  data() {
    return {
      value: "",
      classifyList: [],
      active: 1,
      loading: true
    };
  },
  methods: {
    // 搜索
    search() {
      localStorage.setItem("searchValue", this.value);
      this.$router.push("/search");
    },
    // 获取商品列表
    getclassifyList() {
      let params = {
        showType : '5'
      }
      this.$axios
        .post("operation/operationPosition/showAll",params)
        .then(res => {
          this.classifyList = res.data.data || [];
          this.loading = false
        })
        .catch(() => {
           this.loading = false
        });
    },
    // 去蔬菜类
    goClassify(item) {
      localStorage.setItem("categoryId", item.paramValue);
      switch (item.skipType) {
        case '0':
          window.open(item.skipUrl)
          break;
          case '1':
          this.internalLink(item)  
          break;
            case '2':
          break;
        default:
          break;
      }
    },
    internalLink(item) {
      // 详情为goosDetail;商品分类goodsClass
      // 推荐菜谱详情 menuDetails
      switch (item.skipUrl) {
        case "goodsClass":
          this.$router.push({
            path: "/classify",
            query: { categoryId: item.paramValue, got: "true" }
          });
          break;
        case "goosDetail":
          this.$router.push({
            path: "/details",
            query: { goodsId: item.paramValue, got: "true" }
          });
          break;
        case "menuDetails":
          this.$router.push({
            path: "menuList/detailMenu",
            query: { cookbookId: item.paramValue, got: "true",remark:'my' }
          });
          break;
        default:
          break;
      }
    },

    //搜索
    gosearch() {
      localStorage.removeItem("searchValue");
      this.$router.push("/search");
    }
  }
};
</script>

<style scoped >
.category {
  background-color: #f2f2f2;
  padding-bottom: 40px
}
header {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
}
.cate_bg {
  background-color: #f2f2f2;
  position: fixed;
  width: 100%;
}
.cate_mar {
  margin: 10px 20px !important;
}
.header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: rgba(102, 102, 102, 1);
  position: relative;
  padding-left: 20px;
  background-color: #ededed;
}
.van-search {
  padding: 0;
  border-radius: 17px;
  margin: 20px;
}
header >>> .van-field__left-icon {
  margin: 0 10px;
}
header >>> .van-icon-search {
  font-size: 20px;
}
/* 主体 */
main {
  margin: 100px 10px 20px 20px;
}
main >>> .van-grid-item__content {
  border-radius: 10px;
  /* 修改图片位置 */
  padding-bottom: 10px;
}
.cate-main-grid-span {
  position: absolute;
  top: 6%;
  left: 6%;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
}
main >>> .van-grid-item__content--center {
  padding: 0;
}
main >>> .van-grid-item__content {
  background-color: #f2f2f2 !important;
}
.loading {
  position: fixed;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
}
.van-image{
  height: 124px;
  width: 110px;
}
</style>